export const BASE_URL = process.env.REACT_APP_ROOT_URL
export const USER_LOGIN_URL = 'auth/login'
export const USER_RESET_URL = 'auth/reset/password'
